import {
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CommentModel from './comment';
import type PersonModel from './person';
import TeamBasedModel from './team-based-model';
import type TeamModel from './team';

export default class QuestionModel extends TeamBasedModel {
  declare [Type]: 'question';
  @belongsTo('person', { inverse: 'questions', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @belongsTo('team', { inverse: 'questions', async: true })
  declare team: AsyncBelongsTo<TeamModel>;
  @hasMany('comment', { async: true, inverse: 'question' })
  declare comments: AsyncHasMany<CommentModel>;
  @hasMany('person', { async: true, inverse: null })
  declare assignees: AsyncHasMany<PersonModel>;
}
